// Helpery do zarządzania zawartością konwersacji

/**
 * Scala inkrementalną zawartość z poprzednią zawartością
 * Używane podczas pollingu do dodawania nowych części konwersacji
 * 
 * @param previousContent - poprzednia zawartość HTML
 * @param incrementalContent - nowa zawartość do dodania
 * @param fromTurnId - turn-id od którego zaczyna się nowa zawartość
 * @returns scaloną zawartość HTML
 */
export const mergeIncrementalContent = (
  previousContent: string,
  incrementalContent: string,
  fromTurnId: string
): string => {
  if (!previousContent) return incrementalContent;
  if (!incrementalContent) return previousContent;

  // Znajdź marker turn-id w poprzedniej zawartości
  const marker = `<!-- turn-id:${fromTurnId} -->`;
  const markerIndex = previousContent.indexOf(marker);

  if (markerIndex === -1) {
    // Jeśli nie znaleziono markera, po prostu dodaj na końcu
    return previousContent + incrementalContent;
  }

  // Znajdź koniec tagu zawierającego marker
  const afterMarker = previousContent.substring(markerIndex);
  const closingTagMatch = afterMarker.match(/<\/(div|p|span|section|article)>/i);
  
  if (!closingTagMatch) {
    return previousContent + incrementalContent;
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const cutPosition = markerIndex + closingTagMatch.index! + closingTagMatch[0].length;
  const beforeCut = previousContent.substring(0, cutPosition);
  
  return beforeCut + incrementalContent;
};

/**
 * Oblicza hash zawartości (uproszczona wersja)
 * Używane do wykrywania zmian podczas pollingu
 * 
 * @param content - zawartość do zahashowania
 * @param turnId - turn-id do uwzględnienia w hashu
 * @returns hash jako string
 */
export const computeContentHash = (content: string, turnId: string): string => {
  if (!content || !turnId) return 'none';
  
  // Prosta implementacja - można rozbudować jeśli backend wymaga bardziej złożonego hasha
  const combined = `${content.length}-${turnId}`;
  return btoa(combined).substring(0, 16);
};

/**
 * Pobiera bazowy URL aplikacji
 * @returns bazowy URL (origin)
 */
export const getBaseUrl = (): string => {
  return window.location.origin;
};

